import React from 'react'
import PropTypes from 'prop-types'
import { graphql, Link } from 'gatsby'
import styled from 'styled-components'
import Img from 'gatsby-image'
import parse from 'html-react-parser'
import { device } from '../components/Breakpoints'
import { Breadcrumb } from '../components/Breadcrumb'
import { colors } from '../components/Colors'
import imgbanco from '../img/amamentacao-mobile.png'
import imgmae from '../img/mae-com-bebe.jpg'
import imgCentro from '../img/centro-obstetrico-b.jpg'
import PageHeader from '../components/PageHeader'
import Layout from '../components/Layout'
import VejaTambem from '../components/VejaTambem'
import CentralAtendimento from '../components/CentralAtendimento'

const Container = styled.section`
  width: 100%;
  margin-bottom: 2em;
`

const GroupContent = styled.section`
  padding: 2em 0;
  @media ${device.mobileL} {
    padding: 2em 2em;
  }
  h2 {
    color: ${colors.lilas};
  }
  h4 {
    position: relative;
    margin: 0;
    font-size: 1em;
    padding: 2em;
    padding-left: 0;
    color: #539e9f;
    :before {
      position: absolute;
      content: '';
      top: 24px;
      left: 0;
      border: 1px solid #539e9f;
      width: 5%;
      opacity: 0.5;
      @media ${device.mobileL} {
        left: 0px;
      }
    }
    :after {
      position: absolute;
      content: '';
      bottom: 24px;
      left: 0;
      border: 1px solid #539e9f;
      width: 5%;
      opacity: 0.5;
      @media ${device.mobileL} {
        left: 0px;
      }
    }
    @media ${device.mobileL} {
      padding: 2em 5px 2em 0em;
    }
  }
  .border {
    padding: 1em 2em;
    position: relative;
    border-left: 6px #539e9f solid;
    border-right: 6px #539e9f solid;
    border-bottom: 6px #539e9f solid;
    :before {
      content: '';
      background: #539e9f;
      width: 3%;
      height: 6px;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 2;
      @media ${device.mobileL} {
        width: 6%;
      }
    }
    :after {
      content: '';
      background: #539e9f;
      width: 45%;
      height: 6px;
      position: absolute;
      right: 0;
      top: 0;
      z-index: 2;
      @media ${device.mobileL} {
        width: 35%;
      }
    }
    p {
      font-size: 0.8em;
      @media ${device.mobileL} {
        font-size: 1.2em;
      }
    }
  }
  :nth-of-type(2) {
    background: ${colors.lilasGradiente};
    color: #ffffff;
    p {
      strong {
        color: #ffe17e;
      }
    }
    a {
      text-decoration: none;
      color: #ffe17e;
    }
  }
  :nth-of-type(3) {
    h2 {
      color: ${colors.lilas};
    }
    .estrutura {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 0;
      padding-bottom: 20px;
      flex-wrap: wrap;
      p {
        strong {
          color: ${colors.lilas};
        }
      }
      .gatsby-image-wrapper {
        width: 44%;
        @media ${device.mobileL} {
          width: 100%;
        }
      }
      div {
        width: 50%;
        padding-left: 20px;
        @media ${device.mobileL} {
          width: 100%;
          padding-left: 0px;
        }
      }
    }
    padding-bottom: 2em;
    @media ${device.mobileL} {
      padding: 2em;
    }
  }
  :nth-of-type(4) {
    h2 {
      color: #539e9f;
      margin-top: -52px;
    }
    p {
      strong {
        color: #539e9f;
      }
    }
    .estrutura {
      display: flex;
      align-items: center;
      padding-top: 0;
      flex-wrap: wrap;
      .textoDiv {
        width: 53%;
        @media ${device.mobileL} {
          width: 100%;
        }
      }
      .quadro {
        background: ${colors.verdeGradiente};
        color: #fff8d1;
        width: 39%;
        padding: 4em 2em 5em;
        position: relative;
        right: -87px;
        top: 50px;
        p {
          font-size: 36px !important;
          line-height: 46px !important;
          @media ${device.mobileL} {
            font-size: 16px !important;
            line-height: 1.5em !important;
          }
        }
        @media ${device.mobileL} {
          margin-top: 20px;
          padding: 1em;
          width: 100%;
          position: static;
          right: 0px;
          top: 0px;
        }
      }
    }
    padding-bottom: 4em;
  }
  :nth-of-type(5) {
    background: ${colors.laranjaGradienteReverso};
    color: #ffffff;
    padding: 0;
    .estrutura {
      display: flex;
      align-items: center;
      padding-top: 0;
      flex-wrap: wrap;
      .textoDiv {
        width: 57%;
        @media ${device.mobileL} {
          width: 100%;
        }
      }
      .gatsby-image-wrapper {
        max-width: 479px;
        @media ${device.mobileL} {
          width: 100%;
          padding-top: 20px;
        }
      }
      img {
        max-width: 479px;
        @media ${device.mobileL} {
          width: 100%;
          padding-top: 20px;
        }
      }
    }
    p {
      strong {
        color: #ffe17e;
      }
    }
    @media ${device.mobileL} {
      padding: 2em 2em 0 2em;
    }
  }
  :nth-of-type(6) {
    .estrutura {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0;
      flex-wrap: wrap;
      div {
        width: 57%;
        @media ${device.mobileL} {
          width: 100%;
        }
      }
      .gatsby-image-wrapper {
        width: 40%;
        @media ${device.mobileL} {
          width: 100%;
        }
      }
      img {
        width: 40%;
        @media ${device.mobileL} {
          width: 100%;
        }
      }
    }
    p {
      strong {
        color: #ffe17e;
      }
    }
    padding: 0 0 2em 0;
    @media ${device.mobileL} {
      padding: 2em;
    }
  }
`

export const CentroObstetricoTemplate = ({
  title,
  content,
  slug,
  image,
  color,
  area = 'Centros e Serviços',
  sessoes,
}) => {
  const crumbs = [
    { id: 1, link: '/', title: 'Home', icon: true },
    { id: 2, link: '#', title: area, icon: true },
    {
      id: 3,
      link: slug,
      title,
    },
  ]
  return (
    <>
      <Container>
        <Breadcrumb crumbs={crumbs} />

        <PageHeader
          title={title}
          content={content}
          image={image}
          color={color}
        />

        <GroupContent>
          <div className="inner center">{parse(sessoes[0].texto)}</div>
        </GroupContent>
        <GroupContent>
          <div className="center">
            <h2>{parse(sessoes[1].tituloDaSessao)}</h2>
            {parse(sessoes[1].texto)}
            <div className="estrutura">
              {sessoes[2].imagemDaSessao.localFile ? (
                <Img
                  fluid={
                    sessoes[2].imagemDaSessao.localFile.childImageSharp.fluid
                  }
                  alt="Neopuff "
                />
              ) : (
                <img src={sessoes[2].imagemDaSessao.sourceUrl} alt="Neopuff " />
              )}
              <div>{parse(sessoes[2].texto)}</div>
            </div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="inner border center">
            <h2>{parse(sessoes[3].tituloDaSessao)}</h2>
            {parse(sessoes[3].texto)}
            <h4>{parse(sessoes[4].tituloDaSessao)}</h4>
            {parse(sessoes[4].texto)}
            <div className="estrutura">
              <div className="textoDiv">
                {sessoes[5].listaDeItens.map((item, index) => (
                  <div key={index}>{parse(item.item)}</div>
                ))}
              </div>
              <div className="quadro">{parse(sessoes[6].texto)}</div>
            </div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="center">
            <div className="estrutura">
              <div className="textoDiv">{parse(sessoes[7].texto)}</div>
              <img
                src={sessoes[7].imagemDaSessao.sourceUrl}
                alt="Banco de leite "
              />
            </div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="center">
            <div className="estrutura">
              <div>
                <h2>{parse(sessoes[8].tituloDaSessao)}</h2>
                {parse(sessoes[8].texto)}
              </div>
              {sessoes[8].imagemDaSessao.localFile ? (
                <Img
                  fluid={
                    sessoes[8].imagemDaSessao.localFile.childImageSharp.fluid
                  }
                  alt="Pós-parto"
                  className="offsetImgEnd2"
                />
              ) : (
                <img
                  src={sessoes[8].imagemDaSessao.sourceUrl}
                  alt="Pós-parto"
                  className="offsetImgEnd2"
                />
              )}
            </div>
          </div>
        </GroupContent>
        <CentralAtendimento />
      </Container>
    </>
  )
}

CentroObstetricoTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
}

const CentroObstetrico = ({ data, location }) => {
  const { siteMetadata: site } = data.site
  const { wpPage: page } = data
  const image = page.opEsDaPGina.imagem ? page.opEsDaPGina.imagem.sourceUrl : ''
  const area = location.state ? location.state.area : page.opEsDaPGina.area
  const { paginasRelacionadas } = page.opEsDaPGina
  const { sessaoCustomizada: sessoes } = page.SessoesCustomizadas
  const description = page.excerpt
    ? page.excerpt.replace(/<\/?[^>]+(>|$)/g, '').replace(/\n/g, '')
    : ''

  return (
    <Layout title={`${page.title} – ${site.title}`} description={description}>
      <CentroObstetricoTemplate
        title={page.title}
        content={page.content}
        image={image}
        slug={page.slug}
        color={page.opEsDaPGina.corDoCabecalho}
        area={area}
        sessoes={sessoes}
      />
      <VejaTambem relatedPages={paginasRelacionadas} />
    </Layout>
  )
}

CentroObstetrico.propTypes = {
  data: PropTypes.object.isRequired,
}

export default CentroObstetrico

export const CentroObstetricoQuery = graphql`
  query CentroObstetricoById($id: String!) {
    site {
      siteMetadata {
        url
        title
      }
    }
    wpPage(id: { eq: $id }) {
      title
      content
      slug
      excerpt
      SessoesCustomizadas {
        sessaoCustomizada {
          listaDeItens {
            item
          }
          texto
          tituloDaSessao
          imagemDaSessao {
            sourceUrl
            localFile {
              childImageSharp {
                fluid(quality: 100) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
      opEsDaPGina {
        corDoCabecalho
        area
        imagem {
          sourceUrl
        }
        paginasRelacionadas {
          ... on WpPage {
            id
            title
            slug
          }
        }
      }
    }
  }
`
